// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1235": "9527c244","2629": "42c1483a","3671": "a822944a",}[chunkId] + ".css"
}